<div data-cy="edit-document-dialog" *ngIf="editDocumentForm" [formGroup]="editDocumentForm">
    <div class="tw-flex tw-justify-between tw-items-center">
        <h2 mat-dialog-title class="!pb-4" data-cy="cancel-edit-document-header">
            Edit details
        </h2>
        <button (click)="cancel($event)" class="tw-pr-6">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="tw-grid tw-p-2">
            <mat-form-field appearance="outline" floatLabel="auto" class="tw-w-full tw-mb-8">
                <mat-label>Title</mat-label>
                <input matInput formControlName="title" type="text" data-cy="title">
                <mat-error *ngIf="editDocumentForm.get('title')?.errors">
                    Please enter a document title
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="auto" class="tw-w-full tw-mb-16">
                <mat-label>Type</mat-label>
                <mat-select formControlName="category" data-cy="category"
                    [(value)]="selected"
                >
                    <mat-option *ngFor="let option of (categories$ | async)" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
                <mat-hint>Types include bank statement, signed contract, etc.</mat-hint>
            </mat-form-field>

            <mat-form-field *ngIf="editDocumentForm.get('category').value === 'bankStatement'" appearance="outline" floatLabel="auto" class="tw-w-full tw-mb-8">
                <mat-label>For month</mat-label>
                <mat-select formControlName="monthsString" 
                                data-cy="monthsString"
                                required
                    >
                    @for (month of last24Months; track month;) {
                        <mat-option [value]="month.value">
                            {{ month.display }}
                        </mat-option>
                    }
                    </mat-select>
                <mat-hint>Provide a month of the bank statement</mat-hint>
                <mat-error *ngIf="editDocumentForm.get('monthsString')?.errors">Enter a valid month and year (within last 13 months) as MM/YYYY</mat-error>
            </mat-form-field>
            @if (categoriesRequiringYear.includes(editDocumentForm.get('category').value)) {
                <mat-form-field appearance="outline" floatLabel="auto" class="tw-w-full tw-mb-8 -tw-mt-8">
                    <mat-label>For year</mat-label>
                    <mat-select formControlName="yearsString" 
                                data-cy="yearsString"
                                required
                    >
                    @for (year of years; track year; let i = $index;) {
                        <!-- // Do not show current year when category is tax return -->
                        @if (!editDocumentForm.get('category').value.match('TaxReturn') || i > 0) {
                            <mat-option [value]="year">
                                {{ year }}
                            </mat-option>
                        }
                    }
                    </mat-select>
                <mat-error *ngIf="editDocumentForm.get('yearsString')?.errors">Enter a valid year</mat-error>
                </mat-form-field>
            }
            <mat-form-field appearance="outline" floatLabel="auto" class="tw-w-full tw-mb-8 tw-mt-8">
                <mat-label>Contact</mat-label>
                <mat-select formControlName="contact" 
                            data-cy="contact"
                            required
                            [compareWith]="compareContacts"
                >
                @for (contact of (contacts$ | async); track contact;) {
                    <mat-option [value]="contact">
                        {{contact.first}} {{contact.last}} - {{contact.title ?? 'Owner'}}
                    </mat-option>
                }
            </mat-select>
            <mat-hint>Assign a contact to the document.</mat-hint>
            </mat-form-field>
        </div>
    </mat-dialog-content>

    <mat-divider class="!tw-border-t-2"></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-stroked-button color="accent" class="!tw-mt-4" (click)="cancel($event)">
            Cancel
        </button>
        <button mat-flat-button color="primary" class="!tw-ml-4 !tw-mt-4"
            data-cy="business-details-document-save-btn"
            [disabled]="!editDocumentForm.dirty || !editDocumentForm.valid"
            (click)="save(editDocumentForm)"
        >
            Save
        </button>
    </mat-dialog-actions>
</div>
